<template lang="pug">
div.content
    div.middle-nav(v-if='state===-1')
      div.guide-nav
        img.guide-gif(src='../../assets/Noviceguide/guide.gif')
      button.guide-jump(@click="change(0)") 新手引导
      span.slogan(@click='complete') 跳过
    div.jump-content(v-else)
      zx-course(v-if='state===0',@start="change(1)")
      zx-scene(v-if='state===1',@start="change(2)")
      div.start-div(v-if='state===2')
        div.top-nav
            div.left-nav
              img.logo(:src="logoNav")
              li(v-for='(v,idx) in list2',:class="{active:idx===0}").text {{v}}
            div(style='flex:1;')
            div.rigth-nav
              i.icon-renwu1.iconfont(style='padding-right:8px;')
              p.task-text 任务
              p.task-text(style='color:#D8D8D8;padding-right: 8px;padding-left: 26px;') |
              p.task-text 退出实训
        button.start(@click="start") 开始实训
        .mask3
        div.zhidao
          img(src="../../assets/doCase/jq.png").jq
          img(src="../../assets/Noviceguide/小手.png", alt="提示").finger3
          p.text-Explain(style="    position: relative;    top: 75px;left: 50%;")  体验完毕,进入实训吧
      //- div.jump(v-for='(v,index) in list',v-if='index == state')
      //-   div(@click="state+=1",v-if='state !== 8').ltem-nav
      //-   div(v-else,@click='complete').start
      //-   img(:src="v.taskguide").navigation
</template>
<script>
import course from "./Course.vue";
import scene from "./scene";
export default {
  components: {
    "zx-course": course,
    "zx-scene": scene
  },
  data() {
    return {
      state: -1,
      list2: ["政策制定", "政策执行", "政策评估", "政策终结"],

      list: [
        // eslint-disable-next-line global-require
        { taskguide: require("../../assets/Noviceguide/guide1-1.png") },
        // eslint-disable-next-line global-require
        { taskguide: require("../../assets/Noviceguide/guide1-2.png") },
        // eslint-disable-next-line global-require
        { taskguide: require("../../assets/Noviceguide/guide1-3.png") },
        // eslint-disable-next-line global-require
        { taskguide: require("../../assets/Noviceguide/guide1-4.png") },
        // eslint-disable-next-line global-require
        { taskguide: require("../../assets/Noviceguide/guide1-5.png") },
        // eslint-disable-next-line global-require
        { taskguide: require("../../assets/Noviceguide/guide1-6.png") },
        // eslint-disable-next-line global-require
        { taskguide: require("../../assets/Noviceguide/guide1-7.png") },
        // eslint-disable-next-line global-require
        { taskguide: require("../../assets/Noviceguide/guide1-8.png") },
        // eslint-disable-next-line global-require
        { taskguide: require("../../assets/Noviceguide/guide1-9.png") }
      ]
    };
  },
  methods: {
    complete() {
      /** 关闭新手引导 */
      this.$emit("complete");
    },
    change(index) {
      console.log(index);
      this.state = index;
    },
    start() {
      this.$emit("complete");
    }
  }
};
</script>

<style lang="stylus" scoped>
@import 'css.styl'
.mask3
  background rgba(0, 0, 0, 0.6)
  height 100%
.start-div
  background url('../../assets/case/backrgound.png')
  background-size 100% 100%
  height 100vh
.zhidao
  position absolute
  left 50%
  top 80%
  .jq
    position: fixed;
    top: 50%;
    right: 50%;
    transform: translate(50%, -60%);
@keyframes myfirst3
  from
    left 50%
    top 80%
  to
    left 52%
    top 82%
.finger3
  // transition 1s
  animation myfirst3 0.5s infinite
  animation-direction alternate
  position fixed
.content
  width 100vw
  position fixed
  height 100vh
  overflow hidden
  z-index 100
  .middle-nav
    width 760px
    height 428px
    margin auto
    position absolute
    top 0
    left 0
    right 0
    bottom 0
    background #ffffff
    box-shadow 0px 2px 10px 0px rgba(0, 0, 0, 0.3)
    border-radius 4px
    .guide-nav
      height 256px
      margin 0 auto
      .guide-gif
        width 532px
    .guide-jump
      border none
      outline none
      width 160px
      height 48px
      background rgba(92, 165, 252, 1)
      border-radius 24px
      font-size 16px
      font-family MicrosoftYaHeiUI-Bold
      font-weight bold
      color rgba(255, 255, 255, 1)
      text-align center
      margin-top 82px
      cursor pointer
    .slogan
      font-size 16px
      font-family MicrosoftYaHeiUI-Bold
      font-weight bold
      color rgba(92, 165, 252, 1)
      position relative
      left 58px
      cursor pointer
.jump-content
  background #ffffff
  height 100vh
  .jump
    overflow hidden
    .ltem-nav
      width 200px
      height 68px
      position absolute
      top 85%
      right 30px
      cursor pointer
    .start
      width 200px
      height 68px
      position absolute
      top 85%
      right 30px
      cursor pointer
    .navigation
      width 100vw
      height 100vh
      overflow hidden
</style>
